import { useMutation } from 'react-query'
import { UserProfileType } from '../../../../../types/shared'
import { apiUpdateUser } from '../services/SettingsService'

export default () =>
  useMutation((data: Partial<UserProfileType>) => apiUpdateUser({ userId: data?.id as number, data }))
